import React from 'react'

import Paper from '@material-ui/core/Paper'
import Text from '@material-ui/core/Typography'

function Members() {
	return (
		<Paper style={{ padding: 20, minHeight:800 }} >
			<Text variant='h5' gutterBottom>
				Members
			</Text>
			<Text variant='caption' gutterBottom>
				Members
			</Text>
		</Paper>
	)
}
export default Members
